export const GENERATED_RECIPE_PREVIEW_KEY = 'generatedRecipePreview';
